import React, { useEffect } from "react";

interface Props {
    amount: number;
}

const ApplicationAccepted: React.FunctionComponent<Props> = props => {
    useEffect(() => {
        window.scrollTo(0,0)
    }, [])
    return (
        <div className="loan-container" id="response">
            <div className="top-strip-indicator"></div>
            <div className="d-flex align-items-center flex-column content">
                <div className="check-cirle-container mb-2">
                    <img src="/images/tick.svg" />
                </div>
                <h2 className="text-primary">Tack för din låneansökan</h2>
                <div className="py-5 text-center">
                    <h3>Den har nu skickats till över 35 banker och långivare som kommer lägga sina bästa låneförslag inom 24h. <br /> <br />
                        Vi kontaktar dig inom 24h med det bästa låneförslaget, sedan kan du signera lånet med BankID och få pengarna utbetalda inom ett par dagar.      </h3>
                </div>
            </div>

        </div>
    );
};

export default ApplicationAccepted;
